import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { UIPrimaryButton } from "components/ui/UIButton";
import { useRoute, useParams } from "@bcm-dev/bcms-vite";
import React from "react";
import { ImageAsset, SVGAsset } from "res";
import "./styles.css";
import { CardContainer } from "components/shared/widgets/CardWidget";

/**
 * @function ViewDigitalCardPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ViewDigitalCardPage
 */
export default function ViewDigitalCardPage(props) {
  const cardID = useParams().cardID ?? "0";
  const navigate = useRoute();

  return(
    <MainContentContainer 
      header={ <MainContentHeader text="View Digital Card" /> } 
      className="view-digital-card-page">
      
      <div className="section-container">
        <div className="row digital-card-container">
          <CardContainer dataPoint="View_Digital_Card" showCode={ true } />
        </div>
        <div className="text-center row">
          <ImageAsset id="LoadIcon" className="load-icon" />
        </div>
        <div className="row">
          <p className="sub-text text-center">Card details visible for 1 min 20 sec.</p>
        </div>
        <div className="flex-container row">
          <SVGAsset id="InformationIcon" className="set-width left-inline-icon more-information-icon" />
          <p className="sub-text">Make online and digital wallet purchases while you wait for your physical card. 
            Paying for a subscription or storing this card with a merchant? Be sure to update card details after activation.</p>
        </div>
        <div className="text-center row">
          <UIPrimaryButton onClick={ evt => navigate(`/home/recenttransactions/${ cardID }`) } text="Close" className="button" />
        </div>
      </div>
    </MainContentContainer>
  );
}